var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Artwork",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "165.52107px",
    height: "105.9651px",
    viewBox: "0 0 165.52107 105.9651",
    enableBackground: "new 0 0 165.52107 105.9651",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    fill: "white",
    d: "M150.69807,0H14.82318c-0.5659,0-1.1328,0-1.69769,0.0033c-0.47751,0.0034-0.95391,0.0087-1.43031,0.0217 c-1.039,0.0281-2.0869,0.0894-3.1129,0.2738c-1.0424,0.1876-2.0124,0.4936-2.9587,0.9754 c-0.9303,0.4731-1.782,1.0919-2.52009,1.8303c-0.73841,0.7384-1.35721,1.5887-1.83021,2.52 c-0.4819,0.9463-0.7881,1.9166-0.9744,2.9598c-0.18539,1.0263-0.2471,2.074-0.2751,3.1119 c-0.0128,0.4764-0.01829,0.9528-0.0214,1.4291c-0.0033,0.5661-0.0022,1.1318-0.0022,1.6989V91.142 c0,0.5671-0.0011,1.13181,0.0022,1.69901c0.00311,0.4763,0.0086,0.9527,0.0214,1.4291 c0.028,1.03699,0.08971,2.08469,0.2751,3.11069c0.1863,1.0436,0.4925,2.0135,0.9744,2.9599 c0.473,0.9313,1.0918,1.7827,1.83021,2.52c0.73809,0.7396,1.58979,1.3583,2.52009,1.8302 c0.9463,0.4831,1.9163,0.7892,2.9587,0.9767c1.026,0.1832,2.0739,0.2456,3.1129,0.2737c0.4764,0.0108,0.9528,0.0172,1.43031,0.0194 c0.56489,0.0044,1.13179,0.0044,1.69769,0.0044h135.87489c0.5649,0,1.13181,0,1.69659-0.0044 c0.47641-0.0022,0.95282-0.0086,1.4314-0.0194c1.0368-0.0281,2.0845-0.0905,3.11301-0.2737 c1.041-0.1875,2.0112-0.4936,2.9576-0.9767c0.9313-0.4719,1.7805-1.0906,2.52011-1.8302c0.7372-0.7373,1.35599-1.5887,1.8302-2.52 c0.48299-0.9464,0.78889-1.9163,0.97429-2.9599c0.1855-1.026,0.2457-2.0737,0.2738-3.11069 c0.013-0.4764,0.01941-0.9528,0.02161-1.4291c0.00439-0.5672,0.00439-1.1319,0.00439-1.69901V14.8242 c0-0.5671,0-1.1328-0.00439-1.6989c-0.0022-0.4763-0.00861-0.9527-0.02161-1.4291c-0.02811-1.0379-0.0883-2.0856-0.2738-3.1119 c-0.18539-1.0432-0.4913-2.0135-0.97429-2.9598c-0.47421-0.9313-1.093-1.7816-1.8302-2.52 c-0.73961-0.7384-1.58881-1.3572-2.52011-1.8303c-0.9464-0.4818-1.9166-0.7878-2.9576-0.9754 c-1.0285-0.1844-2.0762-0.2457-3.11301-0.2738c-0.47858-0.013-0.95499-0.0183-1.4314-0.0217C151.82988,0,151.26297,0,150.69807,0 L150.69807,0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "g8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.85) translate(5, -8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6327"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(1.125,0,0,1.125,-11.9755,-13.8615)",
    y2: 81.398598,
    x2: 157.3299,
    y1: 81.398598,
    x1: 117.3856,
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_1_"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop6330",
    style: {
      stopColor: "#007940"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop6332",
    style: {
      stopColor: "#00873F"
    },
    offset: 0.2285
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop6334",
    style: {
      stopColor: "#40A737"
    },
    offset: 0.7433
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop6336",
    style: {
      stopColor: "#5CB531"
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    id: "path6338",
    d: "m 129,82.5 10.5,0 c 0.3,0 1,-0.1 1.3,-0.1 2,-0.4 3.7,-2.2 3.7,-4.7 0,-2.4 -1.7,-4.2 -3.7,-4.7 -0.3,-0.1 -0.9,-0.1 -1.3,-0.1 l -10.5,0 0,9.6 z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(1.125,0,0,1.125,-11.9755,-13.8615)",
    y2: 75.171402,
    x2: 157.3318,
    y1: 75.171402,
    x1: 117.3844,
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop6341",
    style: {
      stopColor: "#007940"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop6343",
    style: {
      stopColor: "#00873F"
    },
    offset: 0.2285
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop6345",
    style: {
      stopColor: "#40A737"
    },
    offset: 0.7433
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop6347",
    style: {
      stopColor: "#5CB531"
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    id: "path6349",
    d: "m 138.3,16.2 c -10,0 -18.2,8.1 -18.2,18.2 l 0,18.9 25.7,0 c 0.6,0 1.3,0 1.8,0.1 5.8,0.3 10.1,3.3 10.1,8.5 0,4.1 -2.9,7.6 -8.3,8.3 l 0,0.2 c 5.9,0.4 10.4,3.7 10.4,8.8 0,5.5 -5,9.1 -11.6,9.1 l -28.2,0 0,37 26.7,0 c 10,0 18.2,-8.1 18.2,-18.2 l 0,-90.9 -26.6,0 z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(1.125,0,0,1.125,-11.9755,-13.8615)",
    y2: 68.399101,
    x2: 157.33051,
    y1: 68.399101,
    x1: 117.3846,
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop6352",
    style: {
      stopColor: "#007940"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop6354",
    style: {
      stopColor: "#00873F"
    },
    offset: 0.2285
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop6356",
    style: {
      stopColor: "#40A737"
    },
    offset: 0.7433
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop6358",
    style: {
      stopColor: "#5CB531"
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    id: "path6360",
    d: "m 143.2,63.1 c 0,-2.4 -1.7,-4 -3.7,-4.3 -0.2,0 -0.7,-0.1 -1,-0.1 l -9.5,0 0,8.8 9.5,0 c 0.3,0 0.9,0 1,-0.1 2,-0.3 3.7,-1.9 3.7,-4.3 z",
    className: "st3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(1.125,0,0,1.125,-11.9755,-13.8615)",
    y2: 75.171402,
    x2: 68.522102,
    y1: 75.171402,
    x1: 27.9594,
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop6363",
    style: {
      stopColor: "#1F286F"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop6365",
    style: {
      stopColor: "#004E94"
    },
    offset: 0.4751
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop6367",
    style: {
      stopColor: "#0066B1"
    },
    offset: 0.8261
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop6369",
    style: {
      stopColor: "#006FBC"
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    id: "path6371",
    d: "m 37.7,16.2 c -10,0 -18.2,8.1 -18.2,18.2 l 0,44.9 c 5.1,2.5 10.4,4.1 15.7,4.1 6.3,0 9.7,-3.8 9.7,-9 l 0,-21.2 15.6,0 0,21.1 c 0,8.2 -5.1,14.9 -22.4,14.9 -10.5,0 -18.7,-2.3 -18.7,-2.3 l 0,38.3 26.7,0 c 10,0 18.2,-8.1 18.2,-18.2 l 0,-90.8 -26.6,0 z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(1.125,0,0,1.125,-11.9755,-13.8615)",
    y2: 75.171402,
    x2: 111.8553,
    y1: 75.171402,
    x1: 72.459503,
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop6374",
    style: {
      stopColor: "#6C2C2F"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop6376",
    style: {
      stopColor: "#882730"
    },
    offset: 0.1735
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop6378",
    style: {
      stopColor: "#BE1833"
    },
    offset: 0.5731
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop6380",
    style: {
      stopColor: "#DC0436"
    },
    offset: 0.8585
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop6382",
    style: {
      stopColor: "#E60039"
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_5_)"
    },
    id: "path6384",
    d: "m 88,16.2 c -10,0 -18.2,8.1 -18.2,18.2 l 0,23.8 c 4.6,-3.9 12.6,-6.4 25.5,-5.8 6.9,0.3 14.3,2.2 14.3,2.2 l 0,7.7 c -3.7,-1.9 -8.1,-3.6 -13.8,-4 -9.8,-0.7 -15.7,4.1 -15.7,12.5 0,8.5 5.9,13.3 15.7,12.5 5.7,-0.4 10.1,-2.2 13.8,-4 l 0,7.7 c 0,0 -7.3,1.9 -14.3,2.2 -12.9,0.6 -20.9,-1.9 -25.5,-5.8 l 0,42 26.7,0 c 10,0 18.2,-8.1 18.2,-18.2 l 0,-91 -26.7,0 z",
    className: "st5"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/JCB.6c595b91cb20478aa4d2dfbe49c070cd.svg";
export { ForwardRef as ReactComponent };